import React from "react";
import LoanCalculator from "./pages/LoanCalculator";
import "./App.css";

const App = () => {
  return <LoanCalculator />;
};

export default App;
